import { jsxs, jsx } from "react/jsx-runtime";
import { BellCurveChart } from "./BellCurveChart.js";
const PRE_COLOR = "#3b82f6";
const POST_COLOR = "#8b5cf6";
function AiqIndexSection({ report, phase }) {
  const { preIndex, postIndex, improvement, estimatedMean, estimatedSigma } = report;
  const renderNumberCard = () => {
    if (phase === "pre") {
      return /* @__PURE__ */ jsx(
        IndexBadge,
        {
          label: "Pre-AIQ 지수",
          value: preIndex,
          color: PRE_COLOR
        }
      );
    }
    if (phase === "post") {
      return /* @__PURE__ */ jsx(
        IndexBadge,
        {
          label: "Post-AIQ 지수",
          value: postIndex,
          color: POST_COLOR
        }
      );
    }
    return /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-4", children: [
      /* @__PURE__ */ jsx(IndexBadge, { label: "Pre-AIQ", value: preIndex, color: PRE_COLOR }),
      /* @__PURE__ */ jsx("span", { className: "text-2xl text-gray-400", "aria-hidden": true, children: "→" }),
      /* @__PURE__ */ jsx(IndexBadge, { label: "Post-AIQ", value: postIndex, color: POST_COLOR }),
      improvement != null && /* @__PURE__ */ jsxs(
        "div",
        {
          className: `ml-2 text-sm font-semibold ${improvement > 0 ? "text-green-600" : improvement < 0 ? "text-red-500" : "text-gray-500"}`,
          children: [
            improvement > 0 ? "▲" : improvement < 0 ? "▼" : "−",
            " ",
            Math.abs(improvement).toFixed(1)
          ]
        }
      )
    ] });
  };
  return /* @__PURE__ */ jsxs("div", { className: "space-y-4", children: [
    /* @__PURE__ */ jsxs("div", { className: "flex items-start justify-between gap-4 flex-wrap", children: [
      /* @__PURE__ */ jsx("p", { className: "text-xs text-gray-500 max-w-prose", children: "Advanced 점수를 일반 IQ 분포(평균 100, 표준편차 15)로 변환한 값입니다. 표준 IQ와 같은 해석이 가능합니다." }),
      /* @__PURE__ */ jsxs(
        "span",
        {
          className: "inline-flex items-center gap-2 px-2 py-1 rounded-md bg-gray-100 text-[10px] text-gray-500 font-mono shrink-0",
          title: "변환에 사용된 모집단 파라미터 (조직 설정 또는 기본값)",
          children: [
            "μ=",
            estimatedMean.toFixed(1),
            ", σ=",
            estimatedSigma.toFixed(1)
          ]
        }
      )
    ] }),
    /* @__PURE__ */ jsx("div", { className: "flex justify-center", children: renderNumberCard() }),
    /* @__PURE__ */ jsx(BellCurveChart, { preIndex, postIndex, phase }),
    phase === "comparison" && preIndex != null && postIndex != null && /* @__PURE__ */ jsxs("div", { className: "flex items-center justify-center gap-6 text-xs text-gray-500", children: [
      /* @__PURE__ */ jsxs("span", { className: "flex items-center gap-1", children: [
        /* @__PURE__ */ jsx(
          "span",
          {
            className: "inline-block w-3 h-3 rounded-full",
            style: { backgroundColor: PRE_COLOR }
          }
        ),
        "Pre-AIQ"
      ] }),
      /* @__PURE__ */ jsxs("span", { className: "flex items-center gap-1", children: [
        /* @__PURE__ */ jsx(
          "span",
          {
            className: "inline-block w-3 h-3 rounded-full",
            style: { backgroundColor: POST_COLOR }
          }
        ),
        "Post-AIQ"
      ] })
    ] })
  ] });
}
function IndexBadge({
  label,
  value,
  color
}) {
  return /* @__PURE__ */ jsxs("div", { className: "flex flex-col items-center", children: [
    /* @__PURE__ */ jsx("span", { className: "text-xs text-gray-500", children: label }),
    /* @__PURE__ */ jsx(
      "span",
      {
        className: "text-3xl font-extrabold tabular-nums",
        style: { color },
        children: value != null ? Math.round(value) : "—"
      }
    )
  ] });
}
export {
  AiqIndexSection
};
//# sourceMappingURL=AiqIndexSection.js.map
